<template>
  <div class="row expanded align-center">
    <div v-if="$store.getters.isDigitalMode">
      <span v-if="timer < 30"
            class="margin-right-1">Autómatikus visszalépés: {{ timer }}s</span>
      <button class="ui button primary local-menu-btn"
              @click="$router.push('/digital')">{{ trans.backToDigitalBtn }}
      </button>
      <!--      <button class="ui button primary local-menu-btn" @click="$modal.show('sum-up-payment-modal')">Test SumUp Modal</button>-->
    </div>
    <div v-else>
      <div v-if="isLoggedIn"
           class="ui buttons">
        <button v-if="getCurrentUserPaymentConfig && getCurrentUserPaymentConfig.enableToPayNegativeBalance
                    && Number(getCurrentClientBalance) < 0"
                class="ui button negative basic border-radius-0"
                @click="openPayNegativeBalanceModal">{{ trans.payNegativeBalanceMenu }}
        </button>
        <button class="ui button primary local-menu-btn"
                @click="openProfileAllInOneModal">{{ trans.profileMenu }}
        </button>
        <button class="ui button primary local-menu-btn"
                @click="logOut">{{ trans.logOutMenu }}
        </button>
      </div>
      <div v-else
           class="ui buttons">
        <button class="ui button primary local-menu-btn"
                @click="openLogInModal">{{ trans.logInMenu }}
        </button>
        <button v-if="!signupDisabled"
                class="ui button primary local-menu-btn"
                @click="openSignUpModal">{{ trans.signUpMenu }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  props: ['isLoggedIn', 'isMobileDevice'],
  data () {
    return {
      timerInitValue: 60 * 2,
      intervalTimer: null,
      timer: 60 * 2,
    }
  },
  methods: {
    openSignUpModal () {
      /* eslint-disable */
      this.$modal.show('sign-up-modal')
    },
    openLogInModal () {
      this.$modal.show('log-in-modal')
    },
    logOut () {
      this.$emit('logout')
    },
    openProfileAllInOneModal () {
      this.$emit('open-all-in-one-modal')
    },
    openPayNegativeBalanceModal () {
      this.$modal.show('pay-negative-balance-modal')
    },
    startDigitalBackToScreenTimer () {
      if (this.intervalTimer !== null) {
        clearInterval(this.intervalTimer);
      }

      let self = this

      this.intervalTimer = setInterval(function () {
        // console.log('timer is running', self.timer)
        if (--self.timer < 0) {
          clearInterval(self.intervalTimer)
          self.$router.push('/digital')
        }
      }, 1000);
    },
    clickEventListener: function () {
      this.timer = this.timerInitValue
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.topMenu,
      signupDisabled: state => state.signupDisabled,
      partnerFinderClientActive: state => state.partnerFinder.client.active,
      partnerFinderUserEnabled: state => state.partnerFinder.userProfile.active,
    }),
    ...mapGetters(['getCurrentClientBalance', 'getCurrentUserPaymentConfig']),
  },
  created () {
    if (this.$store.getters.isDigitalMode) {
      this.startDigitalBackToScreenTimer()
      const self = this
      document.querySelector('body').addEventListener(
        'click',
        this.clickEventListener)
    }
  },
  beforeDestroy () {
    if (this.intervalTimer !== null) {
      clearInterval(this.intervalTimer)
      document.querySelector('body').removeEventListener(
        'click',
        this.clickEventListener)
      this.timer = this.timerInitValue
    }
  },
}
</script>

<style scoped>
.ui.button.primary.local-menu-btn {
  border-radius: 0;
  background: #f2711c;
}

.ui.button.primary.local-menu-btn:hover {
  background: #f3a55d;
}
</style>
